import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Form, Row, Col, Tabs, Tab } from 'react-bootstrap'

import { getChartStatistics } from './reducers/chartStatisticsReducer'

import WithAuth from '../../HOCs/WithAuth'
import LoadingScreen from '../../components/LoadingScreen'
import StatisticsGraph from './components/StatisticsGraph'
import StatisticsTable from './components/StatisticsTable'

import './style.css'

class StatisticsContainer extends Component {

  state = {
    statisticsType: '',
  }

  componentDidMount() {
    this.props.getChartStatistics(this.props.alert)
  }

  handleChange = (e) => this.setState({ [e.target.name]: e.target.value })


  render() {
    const { chartStatistics, fetchingChartStatistics } = this.props
    const { statisticsType } = this.state

    if (fetchingChartStatistics) {
      return <LoadingScreen text="Analyzing data" />
    } else {
      let chartsGraphData = []
      let adrGraphData = []

      if (statisticsType && chartStatistics[statisticsType] && Object.keys(chartStatistics[statisticsType]).length > 0) {
        if (statisticsType === 'all') {
          adrGraphData = [{
            name: 'All Sites',
            'adverse drug reactions': chartStatistics[statisticsType]['adverse drug reactions'] || 0
          }]
          const allChartsDataCopy = { ...chartStatistics[statisticsType] }
          delete allChartsDataCopy['adverse drug reactions']
          chartsGraphData = [{ name: 'All Sites', ...allChartsDataCopy }]
        } else {
          chartsGraphData = Object.keys(chartStatistics[statisticsType]).sort()
            .map(name => {
              const chartDataCopy = { ...chartStatistics[statisticsType][name] }
              delete chartDataCopy['adverse drug reactions']
              return { name, ...chartDataCopy }
            })
          adrGraphData = Object.keys(chartStatistics[statisticsType]).sort()
            .map(name => {
              return {
                name,
                'adverse drug reactions': chartStatistics[statisticsType][name]['adverse drug reactions']
              }
            })
        }
      }

      let nestedChartsGraphData = []
      let nestedADRGraphData = []
      let startPoint = 0
      const elementsPerGraph = Math.floor(document.body.clientWidth / 150)
      while (startPoint < chartsGraphData.length) {
        nestedChartsGraphData.push(chartsGraphData.slice(startPoint, startPoint + elementsPerGraph))
        nestedADRGraphData.push(adrGraphData.slice(startPoint, startPoint + elementsPerGraph))
        startPoint += elementsPerGraph
      }

      return (
        <div className="ChartsContainer" style={{ position: 'relative', overflow: 'visible', marginTop: '10px' }}>
          <Tabs defaultActiveKey="graphs">
            <Tab eventKey="graphs" title="Graphs">
              {chartStatistics && Object.keys(chartStatistics).length > 0 ?
                <Row>
                  <Col xs={12} sm={12} md={8} lg={6}>
                    <Form>
                      <Form.Label>
                        Select type
                      </Form.Label>

                      <Form.Control
                        as='select'
                        name='statisticsType'
                        selected={statisticsType}
                        onChange={this.handleChange}
                      >
                        <option value="">Please make a selection</option>
                        {Object.keys(chartStatistics).map(type => {
                          return (
                            <option key={type} value={type}>
                              {type}
                            </option>
                          )
                        })}
                      </Form.Control>
                    </Form>
                  </Col>
                </Row>
                :
                null
              }

              <br />
              <br />

              {chartsGraphData && chartsGraphData.length > 0 ?
                <>
                  <center>
                    <h3>Patient Charts</h3>
                  </center>
                  {nestedChartsGraphData.map((dataSlice, index) => {
                    return <StatisticsGraph key={`$charts-graph-{index}`} data={dataSlice} />
                  })}
                </>
                :
                null
              }

              {adrGraphData && adrGraphData.length > 0 ?
                <>
                  <center>
                    <h3>Adverse Drug Reactions</h3>
                  </center>
                  {nestedADRGraphData.map((dataSlice, index) => {
                    return <StatisticsGraph key={`$adr-graph-{index}`} data={dataSlice} />
                  })}
                </>
                :
                null
              }

              {(!chartsGraphData || chartsGraphData.length === 0) && statisticsType ?
                <center>
                  <h4>
                    No data to display
                  </h4>
                </center>
                :
                null
              }
            </Tab>

            <Tab eventKey="table" title="Table">
              <StatisticsTable sites={chartStatistics?.sites || null} />
            </Tab>
          </Tabs>
        </div>
      )
    }
  }
}

const mapStateToProps = (state) => {
  return {
    fetchingChartStatistics: state.chartStatisticsReducer.fetchingChartStatistics,
    chartStatistics: state.chartStatisticsReducer.chartStatistics,
    currentUser: state.loginReducer.currentUser,
  }
}

const mapDispatchToProps = {
  getChartStatistics
}

export default WithAuth(connect(mapStateToProps, mapDispatchToProps)(StatisticsContainer))
